<template>
  <div>
    <el-card shadow="never" class="mb-10px">
      <div
        style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;"
      >
        <div style="display: flex;align-items: center;flex-direction: row;">
          <div class="icon-bg">
            <div class="icon-target"></div>
          </div>
          <div style="flex-grow: 1;padding-left: 16px;">
            <div class="mb-1" style="color: #101010;font-size: 18px;">
              {{ displayName }}
            </div>
            <div
              v-if="info.inspectionNo"
              style="display: flex;align-items: center;color: #6C6C6C;font-size: 14px;"
            >
              <span>NO： </span>
              <span>{{ info.inspectionNo }}</span>
              <el-divider direction="vertical" />
              <div>
                <el-tag
                  size="mini"
                  :type="statusTagType(info.status)"
                  :color="info.status == 'R' ? 'white' : ''"
                >
                  {{ info.v_status || 'New' }}
                </el-tag>
              </div>
              <el-divider direction="vertical" />
              <span class="mr-2">{{ '最新更新' }}:</span>
              <span>{{
                `${info.modifyByName || '--'} at ${info.modifyTime || '--'}`
              }}</span>
            </div>
          </div>
        </div>
        <div class="mt-4 ml-75px d-flex">
          <div v-if="allow('M') && isEditPage">
            <el-button size="small" plain @click="optCommand('edit')">
              {{ $l('btn_edit') || '编辑' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('D') && isSubOrDelPage">
            <el-button size="small" plain @click="optCommand('delete')">
              {{ $l('btn_delete') || '删除' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('M') && isSavePage">
            <el-button size="small" plain @click="optCommand('save')">
              {{ $l('btn_save') || '保存' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('I') && isSaveAndSubmitInspectionPage">
            <el-button
              size="small"
              plain
              @click="optCommand('submitAndInspection')"
            >
              {{ $l('btn_submitAndInspection') || '保存并提交检验' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('A') && isSubmitAndAuditPage">
            <el-button size="small" plain @click="optCommand('submitAndAudit')">
              {{ $l('btn_submitAndAudit') || '保存并提交审核' }}
            </el-button>
          </div>
          <div class="ml-2" v-if="allow('C') && isAuditPage">
            <el-button size="small" plain @click="optCommand('review')">
              {{ $l('btn_review') || '审核' }}
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="mt-3">
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :inspectionCode="params.code"
        :status="info.status || 'N'"
        @loadData="loadData"
        @close="closeCurPage"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'

export default {
  mixins: [EditLoading],
  name: 'quality-iqcInspectionReport-detail',
  components: {
    EditForm
  },
  data() {
    return {
      info: {},
      pageTypeCode: 'detail'
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail' && this.pageTypeCode != 'edit'
    },
    displayName() {
      const { materialNo, materialName, inspectionDate, scmName } = this.info
      if (!materialNo && !materialName) {
        return this.$l('header_label_title') || '辅料检验报告'
      }
      return [
        materialNo,
        materialName,
        inspectionDate,
        this.$l('header_label_text') || '辅料检验',
        scmName
      ]
        .filter(Boolean)
        .join(' ')
    },
    // 新增/待质检下才能编辑
    isEditPage() {
      return (
        this.pageType === 'detail' &&
        this.pageTypeCode === 'detail' &&
        this.info.inspectionCode &&
        ['N', 'Q'].includes(this.info.status)
      )
    },
    // 新增状态下才能编辑
    isSavePage() {
      return this.pageTypeCode === 'edit' || this.pageType === 'add'
    },
    // 新增状态下才能保存并提交质检
    isSaveAndSubmitInspectionPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        this.info.status === 'N'
      )
    },
    // 新增状态下才能删除
    isSubOrDelPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        this.info.status === 'N'
      )
    },
    // 待质检才能提交最后审批
    isSubmitAndAuditPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        ['Q'].includes(this.info.status)
      )
    },
    // 最终审批必须是 申请让步和退货
    isAuditPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        ['C', 'R'].includes(this.info.status)
      )
    },
    // 新增状态下才能提交质检
    isSubmitInspectionPage() {
      return (
        this.pageType === 'detail' &&
        this.info.inspectionCode &&
        this.info.status === 'N'
      )
    }
  },
  methods: {
    statusTagType(type) {
      return {
        A: 'success',
        N: 'info',
        D: 'danger',
        Q: 'warning',
        C: '',
        R: 'danger'
      }[type]
    },
    ...mapActions('admin/page', ['close']),

    loadData(data) {
      this.info = { ...data }
    },
    optCommand(menuType) {
      const { inspectionCode } = this.info
      switch (menuType) {
        case 'edit':
          // 编辑
          this.pageTypeCode = 'edit'
          break
        case 'delete':
          // 删除
          this.$refs.editForm.del({ inspectionCode })
          break
        case 'review':
          // OA审批
          this.$refs.editForm.review({ inspectionCode })
          break
        case 'save':
          // 保存
          this.$refs.editForm.save()
          break
        case 'submitAndInspection':
          // 保存并提交检验
          this.$refs.editForm.submitAndInspection({ inspectionCode })
          break
        case 'submitAndAudit':
          // 保存并提交审核
          this.$refs.editForm.submitAndAudit({ inspectionCode })
          break
      }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-card) {
  border: none;
  .el-card__body {
    position: relative;
    padding: 10px 15px;
  }
}

:deep(.el-card.content-card) {
  > .el-card__body {
    height: calc(100% - 20px);
  }
}

.tabs-pane {
  flex-grow: 1;
  padding-top: 16px;
}

.icon-bg {
  --size: 60px;
  width: var(--size);
  height: var(--size);
  background-image: url(./icon/hexagon.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .icon-target {
    width: 100%;
    height: 100%;
    background-image: url(./icon/clothes-hoodie.png);
    background-size: 30px 30px;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}

:deep(.status-tag) {
  font-size: 14px;
  .el-tag--A {
    color: #101010;
    background-color: #f4f4f5;
    border: none;
  }

  .el-tag--B {
    color: #101010;
    background-color: #faecd8;
    border: none;
  }
  .el-tag--C {
    color: #ffffff;
    background-color: #0492ce;
    border: none;
  }
  .el-tag--D {
    color: #ffffff;
    background-color: #fe2812;
    border: none;
  }
  .el-tag--E {
    color: #101010;
    background-color: #fabc05;
    border: none;
  }

  .el-tag--O {
    color: #ffffff;
    background-color: #66b031;
    border: none;
  }
  .el-tag--P {
    color: #ffffff;
    background-color: #0647fe;
    border: none;
  }
  .el-tag--S {
    color: #ffffff;
    background-color: #3d04a4;
    border: none;
  }
}
</style>
